import styled from 'styled-components';
import { Button, Flexbox } from '@hiiretail/synergy-ui';

export const StyledContainer = styled(Flexbox)`
  :first-child, :nth-child(2) {
    margin-bottom: 24px;
  }
`;

export const PrimaryButton = styled(Button)`
  width: 90px;
  
  :disabled {
    background-color: #EED1FE;
    font-weight: 600;
  }
`;

export const SecondaryButton = styled(Button)`
  width: 90px;

  :disabled {
    background: #F5F5F5;
    font-weight: 500;
    color: #9E9E9E;
  }
`;
